import styled, { css } from 'styled-components/macro'
import { transparentize } from 'polished'
import { Href } from 'components/ui'

export const CloseButton = styled.button`
  position: absolute;
  top: 2rem;
  right: 2rem;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  color: ${(props) => props.theme.color.black};
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
`

export const Wrap = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`

export const Container = styled.div`
  margin: 0;
`

export const WarningText = styled.p`
  margin: 0;
  padding: 0 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.4rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.43;
  letter-spacing: -0.032rem;
  text-align: center;
`

export const WrapContent = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  height: 38.2rem;
`

export const WrapContentAirdrop = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  height: 31rem;
`

export const Wrapper = styled.div`
  margin: 0 0 6rem;
`

export const Text = styled.p<{ type?: string; size?: string; align?: string }>`
  margin: 0;
  padding: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.6rem;
  line-height: 1.12;
  text-align: ${(props) => (props.align ? props.align : 'center')};
  word-break: break-word;
  color: ${(props) => props.theme.color.text};
  &::first-letter {
    text-transform: capitalize;
  }
  ${(props) =>
    props.type === 'error' &&
    css`
      color: ${(props) => props.theme.color.danger};
    `}
  ${(props) =>
    props.type === 'support' &&
    css`
      color: ${(props) => transparentize(0.5, props.theme.color.text)};
    `}
  ${(props) =>
    props.size === 'small' &&
    css`
      font-size: 1.4rem;
      line-height: 1.12;
    `}
`

export const StyledLink = styled(Href)`
  padding: 0.4rem 1rem;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  text-align: center;
  color: ${(props) => props.theme.color.textHintSecond};
  border-radius: 0.8rem;
  &:hover {
    color: ${(props) => props.theme.color.text};
    background-color: ${(props) => props.theme.color.buttonBgThird};
  }
`

export const InfoText = styled.p`
  margin: 0.8rem auto 2.4rem;
  max-width: 39.2rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.6rem;
  line-height: 1.5;
  letter-spacing: 0.015rem;
  text-align: center;
  color: ${(props) => transparentize(0.5, props.theme.color.text)};
`

export const InfoTextSmall = styled.p`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.33;
  letter-spacing: -0.03rem;
  text-align: center;
  color: ${(props) => transparentize(0.5, props.theme.color.text)};
`

export const ButtonsWrapMultisend = styled.div`
  margin: 0 auto;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 1.6rem;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    flex-direction: row;
  `};
`
